<template>
  <div class="row">
    <button
        :disabled="!previousMonthAvailable" class="btn-basic btn-outline-pulse"
        style="width: 50px; border-top-right-radius: 0; border-bottom-right-radius: 0;"
        @click="previousMonth">
      <svg
          width="1em" height="1em"
          viewBox="0 0 16 16" class="bi bi-chevron-left"
          fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
      </svg>
    </button>
    <button class="btn-basic btn-fill-pulse w-50" disabled
      style="border-radius: 0; opacity: 1; background-color: #009490">
      {{ this.currentlySelectedMonth | toMonthNameWithYear }}</button>
    <button
        :disabled="!nextMonthAvailable" class="btn-basic btn-outline-pulse"
        style="width: 50px; border-top-left-radius: 0; border-bottom-left-radius: 0;"
        @click="nextMonth">
      <svg
          width="1em" height="1em"
          viewBox="0 0 16 16" class="bi bi-chevron-right"
          fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
      </svg>
    </button>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "MonthSelectComponent",
  computed: {
    ...mapGetters({
      previousMonthAvailable: "timesheet/previousMonthAvailable",
      nextMonthAvailable: "timesheet/nextMonthAvailable",
      currentlySelectedMonth: "time/currentlySelectedMonth",
      currentLoggedInUser: "user/currentLoggedInUser"
    }),
  },
  methods: {
    ...mapActions("timesheet", ['getAllActiveContracts', 'fetchWorkShifts', 'fetchAbsences']),
    ...mapActions("administrationInvoice", ['fetchInvoices']),
    ...mapMutations({
      addMonth: "time/addMonth",
      subtractMonth: "time/subtractMonth"
    }),
    previousMonth() {
      this.subtractMonth();
      this.fetchNewData();
    },
    nextMonth() {
      this.addMonth();
      this.fetchNewData();
    },
    fetchNewData() {
      this.getAllActiveContracts();
      this.fetchWorkShifts();
      this.fetchAbsences();
      if (this.currentLoggedInUser.roles.includes('ROLE_ADMIN')) {
        this.fetchInvoices();
      }
    },
  }
};
</script>

<style scoped>

div {
  margin-bottom: 1rem;
  align-items: center;
}

.month {
  width: 10rem;
}

.look-like-disabled-button {
  opacity: 0.65;
}
</style>